import CodTipoDocumento from "@/enums/CodTipoDocumento";
import { PossibleStates } from "@/enums/PossibleStates";

export default class BenefactorDocument {
  constructor(
    public descDocumento?: string,
    public codTipDocumento?: CodTipoDocumento,
    public numPreSolicitud?: number,
    public seqDocumento?: number,
    public indRequiereValidacion?: "S" | "N",
    public idBeneficiario?: string,
    public codigoRuta?: string,
    public hintUrl?: string,
    public hintText?: string,
    public comentarios?: string,
    public observaciones?: string,
    public motivoRechazo?: string,
    public codRechazo?: number,
    public estado: PossibleStates = PossibleStates.Pendiente,
    public estRecepDoc?: PossibleStates,
    public files?: File[],
    public link?: string,
    public observacionesArr:string[] = observaciones?.split('-'),
    public ayudaUrl?: string,
    public ayudaUrl2?: string,
    public ayudaTexto?: string,
  ) {}

  public get observacionesArray():string[]{
    let array : string[] = [];  
    if(this.observaciones !=null || this.observaciones.length>0){
      // array = this.observaciones.split("-")
    }
    return array

  }

  
}
